import { buildWorkforceConfig, type AuthEnv } from '@brush/auth';

const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID ?? '';

const env: AuthEnv = {
  clientId,
  tenant: import.meta.env.VITE_ENTRA_TENANT ?? '',
  redirectUri: window.location.origin,
  apiScope: import.meta.env.VITE_API_SCOPE ?? '',
};

/**
 * With no real Entra app registered — local dev against the dev-bypass API — skip MSAL
 * entirely and send a placeholder token the API ignores. Set VITE_AUTH_DISABLED=false and
 * provide a real VITE_ENTRA_CLIENT_ID to exercise the production sign-in path.
 */
export const authDisabled =
  import.meta.env.VITE_AUTH_DISABLED === 'true' ||
  !clientId ||
  clientId === '00000000-0000-0000-0000-000000000000';

export const msalConfig = buildWorkforceConfig(env);
export const apiScope = env.apiScope;
/** Empty base URL routes through the Vite dev proxy (/api -> :5080), avoiding CORS. */
export const apiBaseUrl = import.meta.env.VITE_API_BASE_URL ?? '';
